export default __webpack_public_path__ + "static/0007-bcc717460a96dcc54cefd5088ec604f9.png";